import { Component, OnInit, Inject, OnDestroy, ViewContainerRef, Optional } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Environment } from '@environments/interface.environment';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { Subscription, Observable } from 'rxjs';
import { User as UserModel } from '@app/models/user';
import { UserService } from '@app/services/user.service';
import { tap } from 'rxjs/operators';

import { PlatformLocation } from '@angular/common';
import { BaseTrackingService } from '@app/tracking/base-tracking.service';
import { Constants } from '@app/common/constants';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription();
  user$: Observable<UserModel>;

  constructor(
    @Inject(CUSTOMERENVIRONMENT) private environment: Environment,
    /* tslint:disable */
    // Need to inject this service so it will get created
    @Optional() private trackingService: BaseTrackingService,
    /* tslint:enable */
    private titleService: Title,
    private userService: UserService,
    private platformLocation: PlatformLocation,
    private dialog: MatDialog,
    private vcr: ViewContainerRef) {
  }

  ngOnInit(): void {
    this.user$ = this.userService.getOrCreateMe()
      .pipe(tap(myUser => {
        // using a promise here cause of change detection https://github.com/angular/material2/issues/5268
        Promise.resolve(myUser).then((user) => {
          // here we could init things that require the user object, for example a first day wizard
        });
      }));

    this.titleService.setTitle(this.environment.title || Constants.DEFAULT_TITLE);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}

